@if (description) {
  <div
    #tooltip="matTooltip"
    [matTooltip]="description"
    [matTooltipPosition]="'above'"
    matTooltipClass="mg-info-tooltip {{ fullWidth ? 'mg-info-tooltip-full' : '' }}"
    class="flex text-primary cursor-pointer md:cursor-default"
    (click)="tooltip?.toggle()"
  >
    <svg-icon key="info-circle" class="{{ iconClass }}"></svg-icon>
  </div>
}
